import { groupResource, GroupResource } from '@witkac/kartamiejska-resources';
import { Group } from '@witkac/kartamiejska-shared';

import { AbstractModule } from '../abstract.module';

/**
 * Moduł grup klienta
 *
 * @export
 * @class ClientGroupsModule
 * @extends {AbstractModule<GroupResource>}
 */
export class ClientGroupsModule extends AbstractModule<GroupResource> {
  /**
   * Stan store
   *
   * @memberof ClientGroupsModule
   */
  public state = {
    list: []
  };

  public mutations = {
    /**
     * Zapisuje listę grup do store
     *
     * @param localState stan lokalny
     * @param groups lista grup
     */
    saveList(localState: any, groups: Group[]): void {
      localState.list = groups;
    },
    /**
     * Dodaje grupę do store
     *
     * @param localState stan lokalny
     * @param group grupa
     */
    add(localState: any, group: Group): void {
      localState.list.push(group);
    },
    /**
     * Usuwa grupę ze stroe
     *
     * @param localState stan lokalny
     * @param id identyfikator grupy
     */
    remove(localState: any, id: number): void {
      localState.list.splice(
        localState.list.findIndex((group: Group) => group.id === id),
        1
      );
    }
  };

  public actions = {
    /**
     * Pobiera listę grup
     *
     * @param context context
     */
    list: async (context: any): Promise<void> => {
      const groups: Group[] = await this.resource.getUserGroups(context.rootState.client.id);
      context.commit('saveList', groups);
    },
    /**
     * Przypisuje grupę użytkownikowi
     *
     * @param context context
     * @param data dane do wysłania do API
     */
    add: async (context: any, data: any): Promise<void> => {
      await this.resource.setGroupToUser(data);
      const group = await this.resource.get(data.groupId);
      context.commit('add', group);
    },
    /**
     * Usuwa przypisanie do grupy użytkownikowi
     *
     * @param context context
     * @param data dane do wysłania do API
     */
    remove: async (context: any, data: any): Promise<void> => {
      await this.resource.unassignFromGroup(data);
      context.commit('remove', data.groupId);
    }
  };

  constructor() {
    super(groupResource);
  }
}

export default new ClientGroupsModule();
